import { Component } from '@angular/core';
import { HeaderComponent } from "../../components/header/header.component";
import { ButtonComponent } from "../../components/button/button.component";
import { FormSectionComponent } from "../../components/form-section/form-section.component";
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { DateInputComponent } from "../../components/date-input/date-input.component";
import { TextInputComponent } from "../../components/text-input/text-input.component";
import { ImageUploderComponent } from "../../components/image-uploder/image-uploder.component";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { AssessmentService } from '../../services/assessment.service';
import { ActivatedRoute, Router, RouterLink, } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { TimeInputComponent } from '../../components/time-input/time-input.component';
import { FileUploaderComponent } from '../../components/file-uploader/file-uploader.component';
import { NgIf, CommonModule } from '@angular/common';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { RadioComponent } from '../../components/radio/radio.component';
import { FormService } from '../../services/form.service';
import { ValidationService } from '../../services/validation.service';

@Component({
  selector: 'app-assessment-form-page',
  imports: [HeaderComponent, ButtonComponent, FormSectionComponent, TimeInputComponent, SelectInputComponent, DateInputComponent, TextInputComponent, ImageUploderComponent, ReactiveFormsModule, RouterLink, FileUploaderComponent, NgIf, CommonModule, FilterByKeyAndValuePipe, RadioComponent],
  templateUrl: './assessment-form-page.component.html',
  styleUrl: './assessment-form-page.component.css'
})
export class AssessmentFormPageComponent {
  page_name = 'Add Assessment';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  currentDate: string = new Date(Date.now()).toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
  directory = '';
  directory_copied = false;

  notZeroTimeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === '00:00:00') {
      return { zeroTime: true };
    }
    return null;
  }

  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public as: AssessmentService, public ar: ActivatedRoute, public ds: DropdownService, public fs: FormService, public vs: ValidationService) {
    this.form = this.fb.group({
      exam_id: ['', [Validators.required]],
      academic_year_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      total_marks: [1, [Validators.required, Validators.maxLength(3)]],
      subject_id: ['', [Validators.required]],
      passing_marks: [1, [Validators.required, Validators.min(1), Validators.maxLength(3), this.fs.compareControls('total_marks', 'lessThanOrEqual', 'passingMarksExceedTotal', 'Passing marks cannot be greater than total marks', () => this.form)]],
      evaluation_start_date: ['', [Validators.required,]],
      evaluation_end_date: ['', [Validators.required]],
      per_day_target: ['', [Validators.required, Validators.min(1)]],
      grace_period: ['', [Validators.required, this.notZeroTimeValidator.bind(this)]],
      min_time_per_answer_script: ['', [Validators.required, this.notZeroTimeValidator.bind(this)]],
      annotations_required: [false, [Validators.required]],
      no_of_evaluation: ['', [Validators.required]],
      head_examiner_required: [false, [Validators.required]],
      script_he_to_check: ['', [Validators.min(1), Validators.max(100)]],
      type: ['', [Validators.required]],
      // re-evaluation fields
      re_evaluation_required: [false, [Validators.required]],
      re_evaluation_start_date: [''],
      re_evaluation_end_date: [''],
      re_evaluation_last_date: [''],
      re_evaluation_fees: [false],
      amount: [+''],
      no_of_re_evaluations: [1, [Validators.required]],
      re_evaluation_he_required: [false],
      re_evaluation_script_he_to_check: [''],
      qp_pattern: ['', [Validators.required]],
      qp_file: ['', [Validators.required]],
      soe_upload: ['',],
      model_answer_sheet: ['', [Validators.required]],
      rubrics_json: this.fb.array([]),
      // Script config fields
      no_of_pages_per_script: ['', [Validators.required, Validators.pattern(this.vs.code_pattern), Validators.min(1)]],
      hide_script_pages_for_faculty: ['', [Validators.required, Validators.pattern(this.vs.code_pattern), this.fs.compareControls('no_of_pages_per_script', 'lessThanOrEqual', 'hideScriptPagesExceedTotal', 'Pages to hide cannot exceed total pages per script', () => this.form)]],
      hide_script_percentage: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/)]],
      no_of_pages_per_supplement: ['', [Validators.required]],
      hide_supplement_pages_for_faculty: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/), this.fs.compareControls('no_of_pages_per_supplement', 'lessThanOrEqual', 'hideSupplementPagesExceedTotal', 'Pages to hide cannot exceed total pages per supplement', () => this.form)]],
      hide_supplement_percentage: ['', [Validators.required, Validators.pattern(/^[0-9%]*$/), Validators.pattern(/^(0%?|([1-9][0-9]?|100)%?)$/)]],
    });

    this.form.get('head_examiner_required')?.valueChanges.subscribe((value) => {
      this.he_is_required(value);
    });
    this.form.get('re_evaluation_required')?.valueChanges.subscribe((value) => {
      this.updateReEvaluationValidators(value);
    });

    this.form.get('re_evaluation_fees')?.valueChanges.subscribe((value) => {
      this.updateAmountValidator(value);
    });

    this.form.get('re_evaluation_he_required')?.valueChanges.subscribe((value) => {
      this.updateReEvalHeValidator(value);
    });

    // Re-validate passing_marks when total_marks changes
    this.form.get('total_marks')?.valueChanges.subscribe(() => {
      this.form.get('passing_marks')?.updateValueAndValidity();
    });

    // Re-validate hide pages when total pages change
    this.form.get('no_of_pages_per_script')?.valueChanges.subscribe(() => {
      const ctrl = this.form.get('hide_script_pages_for_faculty');
      ctrl?.updateValueAndValidity();
      if (ctrl?.value) ctrl?.markAsDirty();
    });
    this.form.get('no_of_pages_per_supplement')?.valueChanges.subscribe(() => {
      const ctrl = this.form.get('hide_supplement_pages_for_faculty');
      ctrl?.updateValueAndValidity();
      if (ctrl?.value) ctrl?.markAsDirty();
    });

    // Disable % to hide when pages to hide is 0
    this.form.get('hide_script_pages_for_faculty')?.valueChanges.subscribe((val: any) => {
      const pct_ctrl = this.form.get('hide_script_percentage');
      if (Number(val) === 0) {
        pct_ctrl?.setValue('');
        pct_ctrl?.disable();
      } else {
        pct_ctrl?.enable();
      }
    });
    this.form.get('hide_supplement_pages_for_faculty')?.valueChanges.subscribe((val: any) => {
      const pct_ctrl = this.form.get('hide_supplement_percentage');
      if (Number(val) === 0) {
        pct_ctrl?.setValue('');
        pct_ctrl?.disable();
      } else {
        pct_ctrl?.enable();
      }
    });
  }
  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      if (this.params.id) {
        this.patch_form_data(this.params.id)
        if (this.params.action == 'view') {
          this.form.disable();
        } else {
          this.form.enable();
        }
      }
    })
    await this.ds?.get_dropdown_list(['university', 'program', 'stream', 'course', 'subject', 'academic-year', 'college', 'exam', 'level']);
    this.form.get('exam_id')?.valueChanges.subscribe((examId: any) => {
      this.onExamChange(examId);
    });
    this.form.get('subject_id')?.valueChanges.subscribe(() => {
      this.update_directory();
    });
  }

  he_is_required(isRequired: boolean = true) {
    if (isRequired) {
      this.form.get('script_he_to_check')?.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      this.form.get('script_he_to_check')?.updateValueAndValidity();
    } else {
      this.form.get('script_he_to_check')?.clearValidators();
      this.form.get('script_he_to_check')?.setValue('');
      this.form.get('script_he_to_check')?.updateValueAndValidity();
    }
  }

  updateReEvaluationValidators(isRequired: boolean) {
    const fields = ['re_evaluation_start_date', 're_evaluation_end_date', 're_evaluation_last_date', 're_evaluation_fees'];

    if (isRequired) {
      fields.forEach(field => {
        this.form.get(field)?.setValidators([Validators.required]);
        this.form.get(field)?.updateValueAndValidity();
      });
      // Trigger amount validation check based on current fees value
      this.updateAmountValidator(this.form.get('re_evaluation_fees')?.value);
    } else {
      fields.forEach(field => {
        this.form.get(field)?.clearValidators();
        this.form.get(field)?.setValue('', { emitEvent: false });
        this.form.get(field)?.updateValueAndValidity({ emitEvent: false });
      });
      this.form.get('amount')?.clearValidators();
      this.form.get('amount')?.setValue(0, { emitEvent: false });
      this.form.get('amount')?.updateValueAndValidity({ emitEvent: false });

      this.form.get('no_of_re_evaluations')?.clearValidators();
      this.form.get('no_of_re_evaluations')?.setValue(null, { emitEvent: false });
      this.form.get('no_of_re_evaluations')?.updateValueAndValidity({ emitEvent: false });

      // Clear HE validators without triggering their subscriptions
      this.form.get('re_evaluation_he_required')?.setValue(false, { emitEvent: false });
      this.form.get('re_evaluation_script_he_to_check')?.clearValidators();
      this.form.get('re_evaluation_script_he_to_check')?.setValue('', { emitEvent: false });
      this.form.get('re_evaluation_script_he_to_check')?.updateValueAndValidity({ emitEvent: false });
    }
  }

  updateReEvalHeValidator(isRequired: boolean) {
    if (isRequired) {
      this.form.get('re_evaluation_script_he_to_check')?.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      this.form.get('re_evaluation_script_he_to_check')?.updateValueAndValidity();
    } else {
      this.form.get('re_evaluation_script_he_to_check')?.clearValidators();
      this.form.get('re_evaluation_script_he_to_check')?.setValue('');
      this.form.get('re_evaluation_script_he_to_check')?.updateValueAndValidity();
    }
  }

  updateAmountValidator(hasFees: boolean) {
    const amountControl = this.form.get('amount');
    // Only set required if re-evaluation is also required
    const isReEvalRequired = this.form.get('re_evaluation_required')?.value;

    if (hasFees && isReEvalRequired) {
      amountControl?.setValidators([Validators.required]);
    } else {
      amountControl?.clearValidators();
      if (!isReEvalRequired) {
        amountControl?.setValue(0);
      }
    }
    amountControl?.updateValueAndValidity();
  }


  onExamChange(examId: number) {
    if (!examId) {
      this.form.patchValue({
        exam_id: null,
        academic_year_id: null,
        university_id: null,
        college_id: null,
        level_id: null,
        program_id: null,
        stream_id: null,
        subject_id: null,
      }, { emitEvent: false });
      return;
    }
    const examList = this.ds.dropdown_list?.exam_list;
    if (!examList || !examList.length) return;

    const selectedExam = examList.find((e: any) => e?.id == examId);
    if (!selectedExam) return;
    this.form.patchValue({
      exam_id: selectedExam.id,
      academic_year_id: selectedExam.academic_year_id,
      university_id: selectedExam.university_id,
      college_id: selectedExam.college_id,
      level_id: selectedExam.level_id,
      program_id: selectedExam.program_id,
      stream_id: selectedExam.stream_id,
      subject_id: null,
    }, { emitEvent: false });
    this.directory = '';
  }



  async patch_form_data(id: any) {
    try {
      let response = await this.as.get(id, {})
      let patch_data = { ...response.data };
      const subject_id = patch_data.subject_id;
      this.form.patchValue({ ...patch_data });

      // Restore rubrics_json into FormArray (patchValue doesn't populate FormArray from plain array)
      const rubrics_array = this.form.get('rubrics_json') as FormArray;
      rubrics_array.clear();
      if (Array.isArray(patch_data.rubrics_json)) {
        patch_data.rubrics_json.forEach((item: any) => {
          rubrics_array.push(
            this.fb.group({
              question_number: [item.question_number],
              optionality: [item.optionality],
              parent: [item.parent],
              marks: [item.marks]
            })
          );
        });
      }

      const re_eval = patch_data.ReEvaluations;
      this.form.get('re_evaluation_start_date')?.setValue(re_eval?.re_evaluation_start_date || '');
      this.form.get('re_evaluation_end_date')?.setValue(re_eval?.re_evaluation_end_date || '');
      this.form.get('re_evaluation_last_date')?.setValue(re_eval?.re_evaluation_last_date || '');
      this.form.get('re_evaluation_fees')?.setValue(re_eval?.re_evaluation_fees || false);
      this.form.get('amount')?.setValue(re_eval?.amount || null);
      this.form.get('no_of_re_evaluations')?.setValue(re_eval?.no_of_re_evaluations || '');
      this.form.get('re_evaluation_he_required')?.setValue(re_eval?.re_evaluation_he_required || false);
      this.form.get('re_evaluation_script_he_to_check')?.setValue(re_eval?.re_evaluation_script_he_to_check || '');
      // Patch script config fields from first script of this assessment
      const sc = patch_data.script_config;
      if (sc) {
        this.form.patchValue({
          no_of_pages_per_script: sc.no_of_pages_per_script || '',
          hide_script_pages_for_faculty: sc.hide_script_pages_for_faculty || '',
          hide_script_percentage: sc.hide_script_percentage || '',
          no_of_pages_per_supplement: sc.no_of_pages_per_supplement || '',
          hide_supplement_pages_for_faculty: sc.hide_supplement_pages_for_faculty || '',
          hide_supplement_percentage: sc.hide_supplement_percentage || '',
        });
        if (Number(sc.hide_script_pages_for_faculty) === 0) {
          this.form.get('hide_script_percentage')?.disable();
        }
        if (Number(sc.hide_supplement_pages_for_faculty) === 0) {
          this.form.get('hide_supplement_percentage')?.disable();
        }
      }
      this.updateReEvaluationValidators(this.form.get('re_evaluation_required')?.value);

      if (subject_id) {
        setTimeout(() => {
          this.form.patchValue({ subject_id }, { emitEvent: false });
          this.update_directory();
        }, 0);
      }
      console.log(response, "jkjkjjkjkjkjkjjkjkjkjkjkj");
    } catch (error) {
      console.log(error);

    }
  }
  get_invalid_controls(group: any = this.form, prefix = ''): string[] {
    const result: string[] = [];
    Object.keys(group.controls || {}).forEach(key => {
      const ctrl = group.get(key);
      if (!ctrl) return;
      if (ctrl.controls) {
        result.push(...this.get_invalid_controls(ctrl, `${prefix}${key}.`));
      } else if (ctrl.invalid && ctrl.enabled) {
        result.push(`${prefix}${key} = ${JSON.stringify(ctrl.value)} | errors: ${JSON.stringify(ctrl.errors)}`);
      }
    });
    return result;
  }

  async submit(item?: any) {
    console.log(this.form.value);
    if (this.form.invalid) {
      console.warn('INVALID CONTROLS:', this.get_invalid_controls());
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }

    // Check if rubric marks match total_marks before submitting
    const rubrics_array = this.form.get('rubrics_json') as FormArray;
    if (rubrics_array && rubrics_array.length > 0) {
      const exact_marks = this.calculate_exact_marks(rubrics_array.value);
      const form_total_marks = Number(this.form.get('total_marks')?.value || 0);
      if (exact_marks !== form_total_marks) {
        this.gs.toastr_shows_function(`The total rubric marks (${exact_marks}) does not match the total marks (${form_total_marks}) entered.`, 'Error', 'error');
        return;
      }
    }

    // this.fs.is_loading = true;
    let form_value = this.form.getRawValue();
    form_value.total_marks = +form_value.total_marks
    form_value.passing_marks = +form_value.passing_marks
    form_value.no_of_re_evaluations = form_value.no_of_re_evaluations !== '' && form_value.no_of_re_evaluations !== null ? +form_value.no_of_re_evaluations : null
    form_value.re_evaluation_script_he_to_check = form_value.re_evaluation_script_he_to_check !== '' && form_value.re_evaluation_script_he_to_check !== null ? +form_value.re_evaluation_script_he_to_check : null

    // On update, if re_evaluation_required is false, null out all re-evaluation detail fields
    if (this.params.id && !form_value.re_evaluation_required) {
      form_value.re_evaluation_start_date = null;
      form_value.re_evaluation_end_date = null;
      form_value.re_evaluation_last_date = null;
      form_value.re_evaluation_fees = false;
      form_value.amount = null;
      form_value.no_of_re_evaluations = null;
      form_value.re_evaluation_he_required = false;
      form_value.re_evaluation_script_he_to_check = null;
    }

    try {
      if (this.params.id) {
        let update_response = await this.as.update(this.params.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.as.add(form_value);
        this.gs.toastr_shows_function(create_response?.message || 'Assessment created', 'Success', 'success');
      }
      this.route.navigate(['/assessment/list']);
    } catch (error: any) {
      // Show server validation / duplicate messages to user via toast
      const errMsg = error?.error?.message || error?.message || 'Something went wrong';
      this.gs.toastr_shows_function(errMsg, 'Error', 'error');
    } finally {
      // this.fs.is_loading = false;
    }
  }
  update_directory() {
    const exam_id = this.form.get('exam_id')?.value;
    const subject_id = this.form.get('subject_id')?.value;
    const academic_year_id = this.form.get('academic_year_id')?.value;
    const university_id = this.form.get('university_id')?.value;
    const college_id = this.form.get('college_id')?.value;
    const level_id = this.form.get('level_id')?.value;
    const program_id = this.form.get('program_id')?.value;
    const stream_id = this.form.get('stream_id')?.value;

    if (!exam_id || !subject_id) {
      this.directory = '';
      return;
    }

    const examItem = this.ds.dropdown_list?.exam_list?.find((x: any) => x.value == exam_id);
    const subjectItem = this.ds.dropdown_list?.subject_list?.find((x: any) => x.value == subject_id);
    const academicItem = this.ds.dropdown_list?.academic_list?.find((x: any) => x.value == academic_year_id);
    const universityItem = this.ds.dropdown_list?.university_list?.find((x: any) => x.value == university_id);
    const collegeItem = this.ds.dropdown_list?.college_list?.find((x: any) => x.value == college_id);
    const levelItem = this.ds.dropdown_list?.level_list?.find((x: any) => x.value == level_id);
    const programItem = this.ds.dropdown_list?.program_list?.find((x: any) => x.value == program_id);
    const streamItem = this.ds.dropdown_list?.stream_list?.find((x: any) => x.value == stream_id);

    const academic_year_name = academicItem?.name || '';
    const university_code = universityItem?.code || '';
    const college_code = collegeItem?.code || '';
    const level_code = levelItem?.code || '';
    const program_code = programItem?.code || '';
    const stream_code = streamItem?.code || '';
    const exam_code = examItem?.code || '';
    const subject_code = subjectItem?.code || '';

    if (academic_year_name && university_code && exam_code && subject_code) {
      this.directory = `${academic_year_name}/${university_code}/${college_code}/${level_code}/${program_code}/${stream_code}/${exam_code}/${subject_code}`;
    } else {
      this.directory = '';
    }
  }

  copy_directory() {
    if (this.directory) {
      navigator.clipboard.writeText(this.directory);
      this.directory_copied = true;
      setTimeout(() => { this.directory_copied = false; }, 2000);
    }
  }

  calculate_exact_marks(formatted_data: any[]): number {
    const childrenMap: { [key: string]: any[] } = {};
    const rootNodes: any[] = [];

    formatted_data.forEach(item => {
      const parentId = item.parent ? String(item.parent).trim() : '';
      if (parentId) {
        if (!childrenMap[parentId]) {
          childrenMap[parentId] = [];
        }
        childrenMap[parentId].push(item);
      } else {
        rootNodes.push(item);
      }
    });

    const get_node_marks = (node: any): number => {
      const qNum = String(node.question_number).trim();
      const children = childrenMap[qNum] || [];

      if (children.length === 0) {
        return Number(node.marks || 0);
      }

      const childMarks = children.map(child => get_node_marks(child));
      childMarks.sort((a, b) => b - a);

      const opt = Number(node.optionality || 0);
      let marksToTake = childMarks.length;
      if (opt > 0 && opt < childMarks.length) {
        marksToTake = opt;
      }

      let total = 0;
      for (let i = 0; i < marksToTake; i++) {
        total += childMarks[i];
      }
      return total;
    };

    let total_paper_marks = 0;
    rootNodes.forEach(root => {
      total_paper_marks += get_node_marks(root);
    });

    // If no root nodes exist (CSV has only child rows, no explicit parent rows),
    // treat each orphan group as fully mandatory — no optionality constraint
    if (rootNodes.length === 0) {
      const processedParents = new Set<string>();
      rootNodes.forEach(r => processedParents.add(String(r.question_number).trim()));
      Object.entries(childrenMap).forEach(([parentId, children]) => {
        if (!processedParents.has(parentId)) {
          children.forEach(c => {
            total_paper_marks += Number(c.marks || 0);
          });
        }
      });
    }

    return total_paper_marks;
  }

  after_file_upload(parsed_file_data: File) {
    if (!Array.isArray(parsed_file_data)) return;
    const formatted_data = this.convert_to_question_objects(parsed_file_data);
    const rubrics_array = this.form.get('rubrics_json') as FormArray;
    rubrics_array.clear();

    formatted_data.forEach((item: any) => {
      rubrics_array.push(
        this.fb.group({
          question_number: [item.question_number],
          optionality: [item.optionality],
          parent: [item.parent],
          marks: [item.marks]
        })
      );
    });

    const exact_marks = this.calculate_exact_marks(formatted_data);
    const form_total_marks = Number(this.form.get('total_marks')?.value || 0);

    if (exact_marks !== form_total_marks) {
      this.gs.toastr_shows_function(`The total rubric marks (${exact_marks}) does not match the total marks (${form_total_marks}) entered.`, 'Error', 'error');
    } else {
      // this.gs.toastr_shows_function(`Rubric Marks Uploaded Successfully! Total: ${exact_marks}`, 'Success', 'success');
    }

    console.log('Rubrics patched:', rubrics_array.value);
  }

  convert_to_question_objects(rows: any) {
    return rows.map((row: any) => {
      return {
        question_number: String(row["Question Numbers"] ?? row.question_number),
        optionality: Number(row["Optionality"] ?? row.optionality ?? 0),
        parent: row["Parent"] || row.parent || null,
        marks: Number(row["Marks"] ?? row.marks ?? 0)
      }
    });
  }
}
